import { API_CALL_SUCCESS } from '../constants/actionTypes';
import {
    SALES_STATS_GET,
} from '../constants/apiConstants';

const initialState = {};

const apiStatsReducer = (state, action) => {
    const {
        endpoint,
    } = action;

    switch (endpoint) {
    case SALES_STATS_GET:
        const additionalSaleStats = action.response;
        return {
            ...state,
            ...additionalSaleStats,
        };
    default:
        return state;
    }
};

const statsReducer = (state = initialState, action) => {
    const {
        type,
    } = action;

    switch (type) {
    case API_CALL_SUCCESS:
        return apiStatsReducer(state, action);
    default:
        return state;
    }
};

export default statsReducer;
